import React from 'react';

import { VARIANT } from './constant';
import OfferToast from './OfferToast';

export const OfferToastDashboard = (props) => (
  <OfferToast {...props} variant={VARIANT.DASHBOARD} />
);

export const OfferToastSales = (props) => (
  <OfferToast {...props} variant={VARIANT.SALES_INFO} />
);
